/* eslint-disable no-console */
import cookie from '@s-ui/js/lib/cookie'

const STORAGE_CSAT_ENTRY = 'coches_hj_entry'
const EXPIRATION_USER_MARK_MONTHS = 3
const MONTHS_IN_YEAR = 12
const HOTJAR_STORAGE_KEYS = ['_hjMinimizedPolls', '_hjDonePolls', '_hjid']
export const isDevelopment = process.env.NODE_ENV !== 'production'

function logAction(msg) {
  isDevelopment && console.log(msg)
}

function diffMonthsFromNow(date) {
  const now = new Date()
  let date1
  let date2

  if (date < now) {
    date1 = now
    date2 = date
  } else {
    date1 = date
    date2 = now
  }

  const diffYears = date1.getFullYear() - date2.getFullYear()
  const diffMonths = date1.getMonth() - date2.getMonth()
  let totalDiffMonths = diffYears * MONTHS_IN_YEAR + diffMonths

  if (date1.getDate() < date2.getDate()) --totalDiffMonths

  return totalDiffMonths
}

function hasBeenShownRecently() {
  const entryStorageData = window.localStorage && window.localStorage.getItem(STORAGE_CSAT_ENTRY)

  if (!entryStorageData) return false

  const entryDate = new Date(entryStorageData)
  return diffMonthsFromNow(entryDate) <= EXPIRATION_USER_MARK_MONTHS
}

function hasBeenShownBeforeForceResetDay() {
  const entryStorageData = window.localStorage && window.localStorage.getItem(STORAGE_CSAT_ENTRY)

  if (!entryStorageData) return false

  const entryDate = new Date(entryStorageData)
  const forceResetDay = new Date('2022-06-07')
  return entryDate < forceResetDay
}

function forceReset() {
  resetHotjarPolls()
  window.localStorage && window.localStorage.removeItem(STORAGE_CSAT_ENTRY)
  cookie.remove(STORAGE_CSAT_ENTRY)
}

function resetHotjarPolls() {
  HOTJAR_STORAGE_KEYS.forEach(key => {
    window.localStorage && window.localStorage.removeItem(key)
    cookie.remove(key)
  })
}

/**
 * Check if we triggered a csat in this user session
 */
export function hasBeenTriggeredInSession() {
  const entrySessionData = window.sessionStorage.getItem(STORAGE_CSAT_ENTRY)
  const hasBeenTrigered = Boolean(entrySessionData)

  logAction(`CSAT ${hasBeenTrigered ? 'has' : 'has not'} been triggered in this session`)
  return hasBeenTrigered
}

/**
 * We save trigger date in storage and reset after 3 months
 */
export function rememberCsatTrigger() {
  if (hasBeenShownBeforeForceResetDay()) {
    forceReset()
  }

  if (hasBeenShownRecently()) {
    return logAction(`CSAT has been shown in the last ${EXPIRATION_USER_MARK_MONTHS} months`)
  }

  const now = new Date()
  window.localStorage && window.localStorage.setItem(STORAGE_CSAT_ENTRY, now)
  window.sessionStorage.setItem(STORAGE_CSAT_ENTRY, now)
  resetHotjarPolls()
  logAction(`CSAT has been remembered and HJ has been reset`)
}

export function openCsatPoll(pollName) {
  logAction(`CSAT ${pollName} has been trigered`)
  window.hj && window.hj('trigger', pollName)
}
